import React, { createContext, useState, useContext } from 'react';

// Create a context to hold the observer status
const ObserverContext = createContext();

// Custom hook to use the observer context
export const useStopSearch = () => useContext(ObserverContext);

// Provider component that holds the state of IS_OBSERVER
export const StopSearchProvider = ({ children }) => {
  const [stopSearch, setStopSearch] = useState('');


  return (
    <ObserverContext.Provider value={{ stopSearch, setStopSearch }}>
      {children}
    </ObserverContext.Provider>
  );
};
